<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ynf9GB/tc-custom/FC-9781528958554.jpg?1685203880289?1725650298897" alt="This image is the cover for the book Love Project"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love Project
      </h1>
      <p class="bookDescription body article font2">
        <p>A guardian angel is sent to Earth to collect information and write reports on the conflict occurring between the Kingdom of Heaven and the Kingdom of Darkness. What he sees is depressing until a young girl with the ability to see and hear angels accepts to read these reports and, in the process, learns about her forgotten status of royalty in the Kingdom of Heaven. Compelled by the great needs she sees all around her, she starts using her royal position to make a difference in people’s lives. Although very successful in her mission, what she triggers will take her by surprise, leaving even the reporting guardian angel in awe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nick Zamfir
      </h2>
      
      <p class="authorDescription body article">Nick Zamfir is the founder and president of Abiding in Christ Ministries based in Orlando, Florida. Zamfir has a bachelor’s degree in theology from Babes-Bolyai University, Cluj-Napoca, Romania, and has a minor in marriage counselling. He and his wife, Doina, have been married for 33 years and have a 31-year-old son, Alin, and a 27-year-old daughter, Kristina. They have lived in the Orlando for the past 14 years. After accumulating writing experience as a religious columnist for a newspaper, Nick is now writing his fifth book. He also preaches, authors textbooks, and teaches in a school of ministry, and is in his final preparation for an Internet-based television ministry focused on positive, life-changing programs for youth and young adults, and for the non-professing Christian community.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1a7e2e0